<template>
  <a-card :bordered="false">
    <div>
      <a-button type="primary" @click="openModel">绑定商品</a-button>
    </div>
    <custom-page-table
      style="margin-top: 16px;"
      ref="table"
      rowKey="id"
      query-path="directPresale/bind/selectBindProList"
      base-key="directPresaleUrl"
      :queryParams="allQueryParams"
      :columns="columns"
    >
      <span slot="action" slot-scope="rowItem">
        <a-popconfirm title="是否要删除当前绑定？" @confirm="unbind(rowItem.record)">
          <a>删除绑定</a>
        </a-popconfirm>
      </span>
    </custom-page-table>
    <a-modal title="商品绑定" width="700px" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="所属供应商" prop="supplierRelatedId">
          <a-select allowClear v-model="ruleForm.supplierRelatedId" placeholder="请选择">
            <a-select-option v-for="item in providerList" :value="item.id" :key="item.id">{{ item.supplierName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="关联商品" prop="proId">
          <a-button type="primary" @click="toSelectedProductEvent">选择商品</a-button>
          <span v-if="ruleForm.proId" style="margin-left: 3px;">商品ID:{{ ruleForm.proId }}</span>
          <span style="margin-left: 3px;">*仅能关联抢购类型且未上架的自有商品</span>
        </a-form-model-item>
        <a-form-model-item label="供应商商品ID(商品编号)" prop="supplierProId">
          <a-input v-model="ruleForm.supplierProId" placeholder="请输入供应商票型ID(商品编号)"></a-input>
        </a-form-model-item>
        <a-form-model-item v-if="$route.query.serverUniqueId==100017" label="供应商商品规格ID(规格编号)"
                           prop="supplierOptionId">
          <a-input v-model="ruleForm.supplierOptionId" placeholder="供应商商品规格ID(规格编号)"></a-input>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="offsetCol">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存设置</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal title="商品选择" width="750px" :footer="null" :visible="productVisible" @cancel="productCancel">
      <a-form layout="inline">
        <a-form-item label="商品ID">
          <a-input v-model="queryParams.proId" placeholder="请输入商品ID"></a-input>
        </a-form-item>
        <a-form-item label="商品名称">
          <a-input v-model="queryParams.proName" placeholder="请输入商品名称"></a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="$refs.productList.refresh(true)">查询</a-button>
        </a-form-item>
      </a-form>
      <custom-page-table
        style="margin-top: 16px;"
        ref="productList"
        rowKey="proId"
        query-path="directPresale/bind/selectProList"
        base-key="directPresaleUrl"
        :queryParams="queryParams"
        :columns="columnsProduct"
      >
        <span slot="action" slot-scope="rowItem">
          <a @click="onSourceItemClick(rowItem.record)">选择</a>
        </span>
      </custom-page-table>
    </a-modal>
  </a-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'VirtualConnection',
  data() {
    return {
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
      offsetCol: { offset: 7 },
      submitLoading: false,
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        catalogId: 8,
        source: 0,
        state: 0,
        proId: '',
        proName: ''
      },
      allQueryParams: {
        bindType: this.$route.query.serverUniqueId == 100017 ? 1 : 2,
        merchantId: this.$store.getters.userInfo.merchantId
      },
      columns: [
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '类型',
          dataIndex: 'catalogName'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime'
        },
        {
          title: '供应商名称',
          dataIndex: 'supplierName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '160px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      columnsProduct: [
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      selectedType: 0,
      visible: false,
      productVisible: false,
      ruleForm: {
        bindType: this.$route.query.serverUniqueId == 100017 ? 1 : 2,
        merchantId: this.$store.getters.userInfo.merchantId,
        proId: '',
        proName: '',
        supplierProId: '',//供应商商品ID(商品编号)
        supplierRelatedId: undefined,//关联的供应商id
        supplierOptionId: ''
      },
      rules: {
        supplierRelatedId: [
          { required: true, message: '请选择供应商ID', trigger: 'change' }
        ],
        proId: [
          { required: true, message: '请选择供应商商品ID', trigger: 'blur' }
        ],
        supplierProId: [
          { required: true, message: '请输入供应商商品ID(商品编号)', trigger: 'blur' }
        ],
        supplierOptionId: [
          { required: true, message: '请输入供应商商品规格ID(规格编号)', trigger: 'blur' }
        ]
      },
      providerList: [],
      selectedProduct: {},
      optionList: [],
      submitFormData: false
    }
  },
  computed: {
    ...mapState({
      vesion: state => state.config.serverDataInfo.vesion
    })
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'VirtualConnection', title: '商品绑定' },
      { name: 'VirtualOrderConnection', title: '订单直连' },
      { name: 'VirtualRelationAccount', title: '关联账号' }
    ])
  },
  methods: {
    //选择商品
    toSelectedProductEvent() {
      this.productVisible = true
    },
    //商品数据点击
    onSourceItemClick(item) {
      this.getLogUtils().logWithTag('onSourceItemClick', item)
      this.ruleForm.proId = item.proId
      this.ruleForm.proName = item.proName
      this.productVisible = false
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    // 绑定商品
    submitData() {
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitLoading = true
      this.getHttpServices().getDirectPresaleService().post('directPresale/bind/saveBindPro', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.visible = false
        this.$message.success('商品绑定成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //解除绑定
    unbind(item) {
      let parms = {
        merchantId: this.merchantId,
        id: item.id,
        bindType: this.$route.query.serverUniqueId == 100017 ? 1 : 2,
        proId: item.proId
      }
      this.getHttpServices().getDirectPresaleService().post('directPresale/bind/deleteBindPro', parms)
        .then(res => {
          this.$message.success('解除成功')
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getOptionList(proId) {
      this.getHttpServices()
        .getDirectTicketsService()
        .post('directTickets/bind/selectOptionList?pageNum=1&pageSize=9999&proId=' + proId)
        .then(res => {
          this.optionList = res.data
          //this.ruleForm.providerProductOptionId = undefined
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取供应商列表
    getProviderList() {
      this.getHttpServices().getDirectTicketsService().post('directTickets/related/selectAccountDropDownList', {
        merchantId: this.merchantId,
        relatedType: this.$route.query.serverUniqueId == 100017 ? 1 : 2
      }).then(res => {
        this.providerList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    productCancel() {
      this.productVisible = false
    },
    openModel() {
      this.visible = true
      this.ruleForm = {
        bindType: this.$route.query.serverUniqueId == 100017 ? 1 : 2,
        merchantId: this.$store.getters.userInfo.merchantId,
        proId: '',
        proName: '',
        supplierProId: '',//供应商商品ID(商品编号)
        supplierOptionId: '',
        supplierRelatedId: undefined//关联的供应商id
      }
      this.getProviderList()
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
<style scoped></style>

